import { render, staticRenderFns } from "./crypto-order-verify-dialog.vue?vue&type=template&id=31ca001d"
import script from "./crypto-order-verify-dialog.vue?vue&type=script&lang=js"
export * from "./crypto-order-verify-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports